import { default_dashboard } from '@core/breadcrumbs';

const module = default_dashboard
  .extend('voice')
  .add('voice.breadcrumb.title', { name: 'voice.trunk.index' });

const trunks_breadcrumbs = module.extend('voice.trunk.index').add('voice.breadcrumb.trunk.index', {
  name: `voice.trunk.index`
});

const stats_breadcrumbs = module.extend('voice.stats.type').add('shared.breadcrumb.stats.title', {
  name: `voice.stats.index`
});

const voice_breadcrumbs = [trunks_breadcrumbs, stats_breadcrumbs];

export { voice_breadcrumbs };
